import { PlanningTemplateSection } from "types/planning_template";
import { PlanningModel } from "types/planning";

export interface DefaultPlanningTemplate {
  name: string;
  model: PlanningModel;
  sections: PlanningTemplateSection[];
}

export const defaultPlanningTemplates: DefaultPlanningTemplate[] = [
  {
    name: "Construction maison individuelle",
    model: "12_mois",
    sections: [
      {
        section_key: "gros_oeuvre",
        steps: [
          { step_key: "fondation_soubassement", default_weeks: [0, 1, 2] },
          { step_key: "dallage", default_weeks: [3, 4] },
          { step_key: "elevation", default_weeks: [5, 6, 7, 8] },
          { step_key: "dressement", default_weeks: [9] },
          { step_key: "reseaux_exterieurs", default_weeks: [40, 41] },
        ],
      },
      {
        section_key: "assainissement",
        steps: [
          { step_key: "reseaux_assainissement", default_weeks: [2, 3] },
        ],
      },
      {
        section_key: "charpente",
        steps: [
          { step_key: "appor_gabarit", default_weeks: [6] },
          { step_key: "pose_charpente", default_weeks: [10, 11] },
        ],
      },
      {
        section_key: "couverture",
        steps: [
          { step_key: "pose_couverture", default_weeks: [12, 13] },
          { step_key: "goutieres_descentes", default_weeks: [14] },
        ],
      },
      {
        section_key: "etancheite",
        steps: [
          { step_key: "pose_etancheite", default_weeks: [12, 13] },
        ],
      },
      {
        section_key: "menuiserie",
        steps: [
          { step_key: "pose_menuiserie_ext", default_weeks: [15, 16] },
          { step_key: "appros_huisserie", default_weeks: [30] },
          { step_key: "finition_menuiseries", default_weeks: [40, 41] },
        ],
      },
      {
        section_key: "escalier",
        steps: [
          { step_key: "pose_escalier", default_weeks: [38] },
        ],
      },
      {
        section_key: "enduit",
        steps: [
          { step_key: "enduit", default_weeks: [20, 21, 22] },
        ],
      },
      {
        section_key: "ravalement",
        steps: [
          { step_key: "ravalement", default_weeks: [] },
        ],
      },
      {
        section_key: "chape",
        steps: [
          { step_key: "pose_chape", default_weeks: [25] },
          { step_key: "sechage_chape", default_weeks: [26, 27, 28] },
        ],
      },
      {
        section_key: "isolation",
        steps: [
          { step_key: "isolation_combles", default_weeks: [18, 19] },
        ],
      },
      {
        section_key: "cloisonnement",
        steps: [
          { step_key: "plafonds_doublages", default_weeks: [20, 21] },
          { step_key: "cloisonnement", default_weeks: [22, 23] },
          { step_key: "bandes", default_weeks: [24] },
        ],
      },
      {
        section_key: "carrelage",
        steps: [
          { step_key: "chapes", default_weeks: [] },
          { step_key: "sechage_chape", default_weeks: [] },
          { step_key: "pose_carrelages", default_weeks: [34, 35, 36] },
          { step_key: "faience", default_weeks: [34, 35] },
        ],
      },
      {
        section_key: "electricite",
        steps: [
          { step_key: "incorporation_reseaux_dallage_terre", default_weeks: [2, 3] },
          { step_key: "filerie_avant_cloisons", default_weeks: [17, 18] },
          { step_key: "filerie_cloisons", default_weeks: [24, 25] },
          { step_key: "appareillage_tableaux_vmc", default_weeks: [38, 39] },
        ],
      },
      {
        section_key: "plomberie",
        steps: [
          { step_key: "incorporation_reseaux_dallage", default_weeks: [2, 3] },
          { step_key: "incorporations_cloisons_doublages", default_weeks: [22, 23] },
          { step_key: "collecteurs", default_weeks: [24] },
          { step_key: "isolation_sol", default_weeks: [25] },
          { step_key: "preparation_attentes", default_weeks: [26] },
          { step_key: "pose_appareils_sanitaires", default_weeks: [38, 39] },
        ],
      },
      {
        section_key: "photovoltaique",
        steps: [
          { step_key: "installation_pv", default_weeks: [] },
        ],
      },
      {
        section_key: "cuisine",
        steps: [
          { step_key: "pose_cuisine", default_weeks: [40] },
        ],
      },
      {
        section_key: "peinture",
        steps: [
          { step_key: "sous_couche", default_weeks: [30, 31] },
          { step_key: "couche_finition", default_weeks: [42, 43] },
        ],
      },
      {
        section_key: "parquet",
        steps: [
          { step_key: "pose_parquet", default_weeks: [44] },
        ],
      },
      {
        section_key: "controle_re2020",
        steps: [
          { step_key: "controle_re2020_1", default_weeks: [19] },
          { step_key: "controle_re2020_2", default_weeks: [44] },
        ],
      },
      {
        section_key: "livraison",
        steps: [
          { step_key: "mise_en_service", default_weeks: [46] },
          { step_key: "reception", default_weeks: [48] },
        ],
      },
    ],
  },
];
